// Link fra en login-mail (?token_hash=…&type=…): hvilken side skal åbne? Gælder på ENHVER sti – /bekraeft, forsiden
// (Supabases Site URL, fx "Send password recovery" fra dashboardet), /<klient>/ og konsollens subdomæne.
// Koden veksles til et login af api'et (supabase.ts vekslLink); her vælges kun siden.

/** Siden for et login-link, eller null, hvis adressen ikke er et login-link. `hash` er den interne sti efter # (uden #). */
export function linkRute(search: string, hash: string, konsol: boolean): string | null {
  const q = new URLSearchParams(search), type = q.get('type');
  if (!q.get('token_hash') || !type) return null;
  if (q.get('inv') === '1') return '/invitation/inv';
  if (type === 'recovery' || type === 'invite') return '/nulstil/link';
  if (konsol) return '/pixie/konsol';                       // konsollen: engangslinket logger ind dér
  if (hash.startsWith('/')) return hash;                    // linket siger selv, hvor det skal hen (kundens link fra booking-mailen: #/link)
  return type === 'magiclink' || type === 'email_change' ? '/login' : '/pixie/bekraeft';
}
